import BaseRepository from './base.repository';

/**
 * Auth Repository
 * Handles API communication for authentication
 */
class AuthRepository extends BaseRepository {
  constructor() {
    super('auth');
  }

  /**
   * Login with email/phone and password
   * @param {Object} credentials - { username, password }
   * @returns {Promise}
   */
  login(credentials) {
    return this.client.post('/login', credentials);
  }

  /**
   * Login with Facebook access token
   * @param {Object} data - { accessToken }
   * @returns {Promise}
   */
  loginWithFacebook(data) {
    return this.client.post('/facebook/login', data);
  }

  /**
   * Login with Google authorization code
   * @param {Object} data - { code, redirectUri }
   * @returns {Promise}
   */
  loginWithGoogle(data) {
    return this.client.post('/google/login', data);
  }

  /**
   * Get Zalo login URL
   * @returns {Promise}
   */
  getZaloLoginUrl() {
    return this.client.get('/zalo');
  }

  /**
   * Register new account
   * @param {Object} data - { email?, phone?, password, full_name }
   * @returns {Promise}
   */
  register(data) {
    return this.client.post('/register', data);
  }

  /**
   * Forgot password
   * @param {Object} data - { email }
   * @returns {Promise}
   */
  forgotPassword(data) {
    return this.client.post('/forgot-password', data);
  }

  /**
   * Get current user info
   * @returns {Promise}
   */
  getCurrentUser() {
    return this.client.get('/me');
  }
}

export default new AuthRepository();
